import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { LOCALIZATION_STRINGS_ACTION_TYPE } from '../actions/localizationStrings.actions';

const initialState = {
  list: [],
  languages: [],
  languageCode: null,
  enabledStepKeys: [],
  allStepKeys: [],
  inputConceptsByStep: {},
};

const replaceById = (list, originalId, updatedItem) => {
  const index = list.findIndex(item => item.localizationStringId === originalId);

  if (index === -1) {
    return [...list, updatedItem];
  }

  const next = [...list];
  next[index] = updatedItem;

  return next;
};

const localizationStringsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOCALIZATION_STRINGS_ACTION_TYPE.GET_LIST: {
      if (payload?.languageCode && payload.languageCode !== state.languageCode) {
        return state;
      }

      return {
        ...state,
        list: Array.isArray(payload?.items) ? payload.items : [],
      };
    }

    case LOCALIZATION_STRINGS_ACTION_TYPE.UPDATE: {
      const updatedId = payload.item?.localizationStringId;
      const dedupedList = state.list.filter(
        item =>
          item.localizationStringId === payload.originalId ||
          item.localizationStringId !== updatedId,
      );

      return {
        ...state,
        list: replaceById(dedupedList, payload.originalId, payload.item),
      };
    }

    case LOCALIZATION_STRINGS_ACTION_TYPE.DELETE:
      return {
        ...state,
        list: state.list.filter(item => item.localizationStringId !== payload.id),
      };

    case LOCALIZATION_STRINGS_ACTION_TYPE.GET_LANGUAGES:
      return {
        ...state,
        languages: Array.isArray(payload) ? payload : [],
      };

    case LOCALIZATION_STRINGS_ACTION_TYPE.SET_LANGUAGE_CODE:
      return {
        ...state,
        languageCode: payload?.languageCode ?? null,
      };

    case LOCALIZATION_STRINGS_ACTION_TYPE.GET_ENABLED_STEP_KEYS:
      return {
        ...state,
        enabledStepKeys: Array.isArray(payload?.enabledStepKeys) ? payload.enabledStepKeys : [],
        allStepKeys: Array.isArray(payload?.allStepKeys) ? payload.allStepKeys : [],
        inputConceptsByStep: _.isPlainObject(payload?.inputConceptsByStep)
          ? payload.inputConceptsByStep
          : {},
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default localizationStringsReducer;
